import { Switch, styled } from '@mui/material';
import React from 'react'

const SwitchIOS = styled(
  React.forwardRef(function SwitchIOS(props, ref) {
    return (
      <Switch
        ref={ref}
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
      />
    );
  })
)(({ theme }) => ({
    width: 42,
    height: 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(18px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 0,
                // ...theme.applyStyles('dark', {
                //     backgroundColor: '#2ECA45',
                // }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        // '&.Mui-focusVisible .MuiSwitch-thumb': {
        //     color: '#33cf4d',
        //     border: '6px solid #fff',
        // },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.text[100],
            // ...theme.applyStyles('dark', {
            //     color: theme.palette.text[600],
            // }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            // ...theme.applyStyles('dark', {
            //     opacity: 0.3,
            // }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 20,
        height: 20,
    },
    '& .MuiSwitch-track': {
        borderRadius: 24 / 2,
        backgroundColor: theme.palette.text.secondary,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        // ...theme.applyStyles('dark', {
        //     backgroundColor: '#39393D',
        // }),
    },
}));

export default SwitchIOS